(function() {
  function initFilestack() {
    const FILESTACK_API_KEY = 'AVmutL4iQTsGMi9Qj3o6Hz'; // Your API key
    
    if (typeof filestack === 'undefined') {
      console.error('Filestack library not loaded');
      setTimeout(initFilestack, 500);
      return;
    }

    const buttons = document.querySelectorAll('[id^="filestack-btn-"]');
    console.log('Found ' + buttons.length + ' Filestack buttons');
    
    if (buttons.length === 0) {
      // Buttons not in DOM yet, try again
      setTimeout(initFilestack, 500);
      return;
    }

    const client = filestack.init(FILESTACK_API_KEY);
    console.log('Filestack initialized');

    buttons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('Button clicked');
        
        const buttonId = this.id;
        const blockId = buttonId.replace('filestack-btn-', '');
        const hiddenInput = document.getElementById('Field-' + blockId);
        const statusDiv = document.getElementById('status-' + blockId);
        const buttonText = this.querySelector('.file-button-text');

        const options = {
          maxFiles: 1,
          onUploadDone: (result) => {
            if (result.filesUploaded && result.filesUploaded.length > 0) {
              const file = result.filesUploaded[0];
              hiddenInput.value = 'DOWNLOAD FILE: ' + file.url + ' (Filename: ' + file.filename + ')';
              buttonText.textContent = '✓ ' + file.filename;
              statusDiv.innerHTML = '<strong>✓ Uploaded:</strong> ' + file.filename;
              statusDiv.className = 'file-upload-status success';
            }
          }
        };

        client.picker(options).open();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilestack);
  } else {
    initFilestack();
  }
})();